import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import withMixpanel, { SCREEN_VIEW_PEOPLE_REQUESTS } from 'utils/mixpanel'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import { isEqual, getPaginationObject } from 'utils/misc'

import * as toastModule from 'modules/toast'
import * as peopleModule from 'modules/people'
import * as popoverModule from 'modules/popover'
import * as userActions from 'actions/userActions'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user) || null,
        data: idx(state, _ => _.people.requests.items),
        tableLoading: idx(state, _ => _.people.loading),
        organisation: idx(state, _ => _.organisation.selected),
      }
    },
    (dispatch) => {
      const actions = {
        ...userActions,
        ...toastModule,
        ...peopleModule,
        ...popoverModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      bulkSelected: false,
      selectedPeople: [],
      filters: {
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setAllPeople: state => selectedPeople => ({
        ...state,
        bulkSelected: !state.bulkSelected,
        selectedPeople: state.bulkSelected ? [] : selectedPeople,
      }),
      setState: state => object => ({
        ...state,
        ...object
      }),
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
    onBulkSelect: ({ setAllPeople, data }) => () => {
      setAllPeople(Object.keys(data))
    },
    onRequestAccept: ({
      actions, setState, organisation, filters, setPagination
    }) => (requests) => {

      actions.acceptRequests(organisation, requests, () => {
        const userString = requests.length > 1 ? 'users' : 'user'
        actions.showToast(toastModule.SUCCESS_TOAST, `Successfully approved ${userString} to ${organisation.name}`)
        actions.getPeopleRequests(organisation, filters, setPagination)
        actions.showPopover(
          popoverModule.PEOPLE_ASSIGN_GROUPS,
          {
            filterAssignedGroups: false,
            requestCount: requests.length,
            onConfirm: (groups) => {
              setState({bulkSelected: false, selectedPeople: []})
              actions.hideToast()
              actions.assignPeopleToGroups(organisation, requests.map(r => r.userUuid), groups, () => {
                const groupString = groups.length > 1 ? 'groups' : 'group'
                actions.hidePopover()
                actions.showToast(toastModule.SUCCESS_TOAST, `Successfully assigned ${userString} to ${groupString}`)
              })
            }
          }
        )
      })
    },
    onRequestDeny: ({ 
      actions, organisation, setState, filters, setPagination
    }) => (requests) => {
      actions.denyRequests(organisation, requests, () => {
        setState({ bulkSelect: false, selectedPeople: [] })
        actions.hideToast()
        actions.getPeopleRequests(organisation, filters, setPagination)
      })
    },
    onItemSelect: props => (person) => {
      const selectedPeople = [...props.selectedPeople]
      const userIndex = selectedPeople.indexOf(person)

      if (userIndex > -1) {
        selectedPeople.splice(userIndex, 1)
      } else {
        selectedPeople.push(person)
      }
      props.setState({
        selectedPeople,
        bulkSelected: false,
      })
    },
  }),
  lifecycle({
    componentDidMount() {
      const { 
        track, actions, organisation, filters, setPagination
      } = this.props
      
      track(SCREEN_VIEW_PEOPLE_REQUESTS)
      actions.getPeopleRequests(organisation, filters, setPagination)
    },
    componentDidUpdate(prevProps) {
      const {
        actions,
        filters,
        organisation,
        setPagination,
        onRequestDeny,
        selectedPeople,  
        onRequestAccept, 
      } = this.props

      if (prevProps.selectedPeople.length !== selectedPeople.length) {
        if (selectedPeople.length === 0) {
          actions.hideToast()
        } else {
          actions.showToast(toastModule.SELECTED_REQUESTS_TOAST, {
            manual: true,
            data: selectedPeople,
            onDeny: () => {
              onRequestDeny(selectedPeople)
            },
            onAccept: () => {
              onRequestAccept(selectedPeople)
            },
          })
        }
      }

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getPeopleRequests(organisation, filters, setPagination)
      }
    },
  })
)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleRequests/PeopleRequests.enhancer.js